<template>
  <div class="breadcrumbs">
    <NuxtLink to="/" :aria-label="$t('shared.domain')">
      {{ $t('shared.nav.start') }}
    </NuxtLink>
    /
    <NuxtLink :to="{ name: 'offers-city', params: { city: 'stockholm' }}">
      {{ $t('shared.nav.offers') }}
    </NuxtLink>
    /
    <NuxtLink to="/stockholm-fashion-week">
      Stockholm Fashion Week
    </NuxtLink>
  </div>
</template>

<script setup>
// 
</script>
